import {
  DocumentServicesObject,
  EditorClientSpecMapEntry,
} from '@wix/document-services-types';
import { InstallInitiator } from '@wix/editor-platform-sdk-types';
import type { AppInstallOption } from '@wix/editor-platform-host-integration-apis';
import { collectRuntimeDependencyAppIds } from '../utils/appMarketService/appDependencies';
import { getEditorType } from './intentInstallService/helpers';

export const COMPANION_APP_DEPENDENCIES_INSTALL_SPEC =
  'installCompanionAppDependencies';

export const getMissingDependencyAppDefinitionIds = (
  documentServicesAPI: DocumentServicesObject,
  rootAppDefinitionId: string,
): string[] => {
  const rootAppData = documentServicesAPI.platform.getAppDataByAppDefId(
    rootAppDefinitionId,
  ) as unknown as EditorClientSpecMapEntry | undefined;
  const appIds = collectRuntimeDependencyAppIds(rootAppData?.dependencies);

  return [...new Set(appIds)].filter(
    (appDefId) =>
      appDefId &&
      appDefId !== rootAppDefinitionId &&
      !documentServicesAPI.platform.isAppActive(appDefId),
  );
};

export const createDependencyInstallOrigin = (rootAppDefinitionId: string) => ({
  type: getEditorType(),
  initiator: InstallInitiator.Dependency_Service,
  info: {
    appDefinitionId: rootAppDefinitionId,
  },
});

export const createDependencyAppInstallOption = (
  rootAppDefinitionId: string,
): AppInstallOption => ({
  origin: createDependencyInstallOrigin(rootAppDefinitionId),
  headlessInstallation: true,
});

export const getMissingAppDependenciesInstallData = (
  documentServicesAPI: DocumentServicesObject,
  rootAppDefinitionIds: string[],
): {
  appDefinitionIds: string[];
  appsOptions: Record<string, AppInstallOption>;
} => {
  const appDefinitionIds: string[] = [];
  const appsOptions: Record<string, AppInstallOption> = {};
  const seen = new Set<string>();

  rootAppDefinitionIds.forEach((rootAppDefinitionId) => {
    getMissingDependencyAppDefinitionIds(
      documentServicesAPI,
      rootAppDefinitionId,
    ).forEach((dependencyAppDefinitionId) => {
      if (seen.has(dependencyAppDefinitionId)) {
        return;
      }

      seen.add(dependencyAppDefinitionId);
      appDefinitionIds.push(dependencyAppDefinitionId);
      appsOptions[dependencyAppDefinitionId] =
        createDependencyAppInstallOption(rootAppDefinitionId);
    });
  });

  return { appDefinitionIds, appsOptions };
};
